import { Label, Layout, Panel, Textbox, } from "@mcleod/components";

export abstract class AutogenLayoutLinkTender extends Layout {
    labelDesc: Label;
    panel1: Panel;
    panel2: Panel;
    txtOrderId: Textbox;
}
